import { commonFilter } from "./filter";

export default {
  pageName: 'Steam Realtime Ratings',
  pageId: '20117',
  pagePath: '/opinion/SteamPerformance/RealtimeRatings',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
  },
};
